import Layout from '@/components/Layout';
import { PATH, TrackingStatus } from '@/constants';
import { Receiver } from '@/constants/enum';
import useConfirmationNavigate from '@/hooks/useConfirmationNavigate';
import { BlockStack } from '@shopify/polaris';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';
import emailSlice from '@/redux/features/email.slice';
import TemplateEditor from './components/TemplateEditor';
import TemplateHeading from './components/TemplateHeading';

const EmailTemplatesDetail = () => {
  const navigate = useConfirmationNavigate();
  const dispatch = useDispatch();
  const { status } = useParams();
  const [searchParams] = useSearchParams();
  const receiver = searchParams.get('receiver');

  // Drive the active order status from the route param so changing it goes
  // through the navigation confirmation (instead of an eager dispatch that
  // silently discards unsaved edits before the confirm dialog appears).
  useEffect(() => {
    if (status) dispatch(emailSlice.actions.handleChangeOrderStatus(status as TrackingStatus));
  }, [status, dispatch]);

  // Same idea for the "Send to" receiver: TemplateHeading drives it through the
  // route as ?receiver=, so a dirty form hits the confirm modal first; once the
  // navigation commits, sync the active template tab here.
  useEffect(() => {
    if (receiver === Receiver.Customer || receiver === Receiver.Merchant) {
      dispatch(emailSlice.actions.handleChangeEmailTemplatesTab(receiver));
    }
  }, [receiver, dispatch]);

  return (
    <Layout
      fullWidth
      maxWidth="75rem"
      backAction={{
        content: 'Back to Email Templates',
        onAction: () => navigate(PATH.NOTIFICATIONS),
      }}
      title="Edit notification template"
    >
      <BlockStack gap="400">
        <TemplateHeading />

        <TemplateEditor />
      </BlockStack>
    </Layout>
  );
};

export default EmailTemplatesDetail;
